var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQPauseOutline = function SvgQPauseOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.617,
    height: 8.138,
    x: 8.668,
    y: 7.931,
    rx: 0.809
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.617,
    height: 8.138,
    x: 13.715,
    y: 7.931,
    rx: 0.809
  })));
};
export { SvgQPauseOutline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDIxQzE2Ljk3MDYgMjEgMjEgMTYuOTcwNiAyMSAxMkMyMSA3LjAyOTQ0IDE2Ljk3MDYgMyAxMiAzQzcuMDI5NDQgMyAzIDcuMDI5NDQgMyAxMkMzIDE2Ljk3MDYgNy4wMjk0NCAyMSAxMiAyMVpNMTIgMjJDMTcuNTIyOCAyMiAyMiAxNy41MjI4IDIyIDEyQzIyIDYuNDc3MTUgMTcuNTIyOCAyIDEyIDJDNi40NzcxNSAyIDIgNi40NzcxNSAyIDEyQzIgMTcuNTIyOCA2LjQ3NzE1IDIyIDEyIDIyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjguNjY3OTciIHk9IjcuOTMxMTUiIHdpZHRoPSIxLjYxNzE0IiBoZWlnaHQ9IjguMTM3OTQiIHJ4PSIwLjgwODU2OSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjEzLjcxNDgiIHk9IjcuOTMxMTUiIHdpZHRoPSIxLjYxNzE0IiBoZWlnaHQ9IjguMTM3OTQiIHJ4PSIwLjgwODU2OSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";